import { EMBED_VIDEO_SERVICE_URL } from 'config';

const EMBED_VIDEO_V1_URL = `${EMBED_VIDEO_SERVICE_URL}/api/v1/embed-video`;

export const SOCIAL_SHARE_STATS_URL = `${EMBED_VIDEO_V1_URL}/social-share/statistics`;
